<template>
  <div class="h-full w-full px-2 mt-16 pt-7">
    <template v-if="genre.id">
      <genre-place-list
        @openPlace="onOpenPlace"
        :genre="genre"
      />
    </template>
    <template v-else>
      <template v-if="searchWord.length > 0">
        <search-result
          :searchWord="searchWord"
          @selectGenre="onSelectGenre"
          @openPlace="onOpenPlace"
        />
      </template>
      <template v-else>
        <history @openPlace="onOpenPlace" class="mt-2" />
      </template>
    </template>
  </div>
</template>

<script>
import History from './History'
import SearchResult from './SearchResult'
import GenrePlaceList from './GenrePlaceList'

export default {
  components: {
    History,
    SearchResult,
    GenrePlaceList
  },
  props: {
    genre: {
      type: Object,
      required: true
    },
    searchWord: {
      type: String,
      required: true
    },
    searchType:{
      type: String,
      required: false
    }
  },
  methods: {
    onSelectGenre: function (genre) {
      this.$emit('selectGenre', genre)
    },
    onOpenPlace: function (place) {
      this.$store.dispatch('drawer/close')
      this.$emit('selectGenre', {})
      this.$store.dispatch('map/updateSpotMarkerList', [])
      if (place.isGooglePlace || place.isEkispertPlace) {
        this.$store.dispatch('map/updateGooglePlaceMarker', place)
      } else {
        this.$gtag.event("POI詳細表示", {
          poi_id: place.id,
          poi_name: place.name
        });
      }
      this.$store.dispatch('drawer/openPlace', { place: place, full: true })
    }
  }
}
</script>
